/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import ReactIs from 'react-is';
import PropTypes from 'prop-types';
import { config as fdConfig } from '@facet-wealth/design';

export const openPrefilledGmail = ({ to, subject, body }) => {
  let link = 'https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1';

  if (to) link = `${link}&to=${encodeURIComponent(to)}`;
  if (subject) link = `${link}&su=${encodeURIComponent(subject)}`;
  if (body) link = `${link}&body=${encodeURIComponent(body)}`;

  return link;
};

export const openGmailThread = (threadId) => {
  const url = `https://mail.google.com/mail/u/0/#inbox/${threadId}`;
  window.open(url, '_blank');
};

export const getGmailThreadUrl = (threadId) => {
  return `https://mail.google.com/mail/u/0/#inbox/${threadId}`;
};

const jsImportPromises = {};
const _actuallyImportJSFrom = (src) => new Promise((resolve, reject) => {
  const element = document.createElement('script');
  element.src = src;
  element.onload = resolve;
  element.onerror = reject;
  document.head.appendChild(element);
});
const importJSFrom = async (src) => {
  // If there's already been a request to import some JS, regardless of if it's completed or not, return that same promise
  const alreadyImported = jsImportPromises[src];
  if (alreadyImported) {
    return alreadyImported;
  }

  // We haven't already started importing this JS, so start doing so
  jsImportPromises[src] = _actuallyImportJSFrom(src);
  return jsImportPromises[src];
};

const cssImportPromises = {};
const _actuallyImportCSSFrom = (src) => new Promise((resolve, reject) => {
  const element = document.createElement('link');
  element.rel = 'stylesheet';
  element.href = src;
  element.onload = resolve;
  element.onerror = reject;
  document.head.appendChild(element);
});
const importCSSFrom = async (src) => {
  // If there's already been a request to import some CSS, regardless of if it's completed or not, return that same promise
  const alreadyImported = cssImportPromises[src];
  if (alreadyImported) {
    return alreadyImported;
  }

  // We haven't already started importing this CSS, so start doing so
  cssImportPromises[src] = _actuallyImportCSSFrom(src);
  return cssImportPromises[src];
};


export const importMomentTimezone = async () => {
  // In order to import moment-timezone globally, we must first export moment globally
  window.moment = moment;
  // Now we can import it
  await importJSFrom('https://cdn.jsdelivr.net/npm/moment-timezone@0.5.48/builds/moment-timezone-with-data.min.js');
  // And finally, we can return it
  return window.moment;
};

export const importRecharts = async () => {
  // In order to import recharts globally, we must first export some react things globally
  window.forwardRef = forwardRef;
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.ReactIs = ReactIs;
  window.PropTypes = PropTypes;
  // Now we can import it
  await importJSFrom('https://unpkg.com/recharts@3.1.2/umd/Recharts.js');
  // Let's also use it in FD
  fdConfig.setRecharts(window.Recharts);
  // And finally, we can return it
  return window.Recharts;
};

export const importStripeJS = async () => {
  await importJSFrom('https://js.stripe.com/v3/');
};

export const importYodleeFastLink = async () => {
  await importJSFrom('https://cdn.yodlee.com/fastlink/v4/initialize.js');
};

export const importFontAwesomeV4 = async () => {
  await importCSSFrom('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
};
